import { LoadingStatusType } from "@/enums/enums";
import { ToContactList } from "@/service/contact/contactFacade";
import API from "@/service/Index";
import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";

@Module({ namespaced: true })
export default class Contact extends VuexModule {
  public contactModelList: any = [];
  public contactModelListLoadingStatus: LoadingStatusType = LoadingStatusType.None;

  get getContactModelList() {
    return this.contactModelList;
  }

  get getContactModelListLoadingStatus() {
    return this.contactModelListLoadingStatus;
  }

  @Mutation
  public MutationSetContactModelListLoadingStatus(status: LoadingStatusType) {
    this.contactModelListLoadingStatus = status;
  }

  @Mutation
  public MutationContactModelList(_contactModelList: any) {
    this.contactModelList = [...this.contactModelList, ..._contactModelList];
  }

  @Action
  public DoGetContactByContactIdList(contactIdList: Array<number>) {
    return new Promise((resolve) => {
      if (this.contactModelListLoadingStatus !== LoadingStatusType.Loading) {
        this.context.commit("MutationSetContactModelListLoadingStatus", LoadingStatusType.Loading);
        contactIdList = [...new Set(contactIdList)];
        let contactIdForSearch = [] as Array<number>;
        if (this.contactModelList && this.contactModelList.length > 0) {
          contactIdList.forEach((contactId) => {
            const contactOnLocal = this.contactModelList.find((x: any) => x.id === contactId);
            if (!contactOnLocal) {
              contactIdForSearch.push(contactId);
            }
          });
        } else {
          contactIdForSearch = contactIdList;
        }

        if (contactIdForSearch.length > 0) {
          API.ContactService.DoGetContactByContactIdList(contactIdForSearch).then((res) => {
            if (res.data.responseCode.IsSuccess()) {
              const contactModelList = ToContactList(res.data.contactList);
              this.context.commit("MutationContactModelList", contactModelList);
            }
            this.context.commit("MutationSetContactModelListLoadingStatus", LoadingStatusType.Success);
            resolve("resolved");
          });
        } else {
          setTimeout(() => {
            this.context.commit("MutationSetContactModelListLoadingStatus", LoadingStatusType.Success);
            resolve("resolved");
          }, 250);
        }
      }
    });
  }
}
